var _rect, _g, _rect2, _path, _g2, _rect3, _path2, _g3, _rect4, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoRatings = function SvgNoRatings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 160,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    x: 46,
    fill: "#EFF3FB",
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#noRatings_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 32,
    x: 16,
    y: 20,
    fill: "#fff",
    rx: 8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 6,
    x: 52,
    y: 33,
    fill: "#B3B3B3",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "m32.364 38.812-4.296 3.102 1.693-5.045-4.306-3.114h5.272l1.637-5.045L34 33.755h5.273l-4.307 3.114 1.693 5.045z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#noRatings_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 32,
    x: 96,
    y: 64,
    fill: "#fff",
    rx: 8
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 6,
    x: 146,
    y: 77,
    fill: "#B3B3B3",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "m112.364 82.812-4.296 3.102 1.693-5.045-4.306-3.114h5.272l1.637-5.045L114 77.755h5.273l-4.307 3.114 1.693 5.045zm16.734 0-4.295 3.102 1.693-5.045-4.307-3.114h5.273l1.636-5.045 1.636 5.045h5.273L131.7 80.87l1.693 5.045z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#noRatings_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 32,
    x: 16,
    y: 108,
    fill: "#fff",
    rx: 8
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 6,
    x: 81,
    y: 121,
    fill: "#B3B3B3",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "m32.364 126.812-4.296 3.102 1.693-5.045-4.306-3.114h5.272l1.637-5.045L34 121.755h5.273l-4.307 3.114 1.693 5.045zm16.734 0-4.295 3.102 1.693-5.045-4.307-3.114h5.273l1.636-5.045 1.636 5.045h5.273l-4.307 3.114 1.694 5.045zm16.734 0-4.295 3.102 1.693-5.045-4.307-3.114h5.273l1.636-5.045 1.637 5.045h5.273l-4.307 3.114 1.693 5.045z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "noRatings_svg__a",
    width: 172,
    height: 64,
    x: 0,
    y: 8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1364_118694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1364_118694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noRatings_svg__b",
    width: 172,
    height: 64,
    x: 80,
    y: 52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1364_118694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1364_118694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noRatings_svg__c",
    width: 172,
    height: 64,
    x: 0,
    y: 96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1364_118694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1364_118694",
    result: "shape"
  })))));
};
export default SvgNoRatings;